$(document).ready(function() {
  // Reset tracking UI state
  function resetTrackingUI() {
    $('.trackOrder').hide();
    $('.no-trackOrder').hide();
    $('.IncorrectTrackOrder').hide();
    $('.MainTrackOrder').show();
    $('.before_loader-gif').show();
    $('[id^="js-courier_awb"]').text('');
    $('[id^="js-courier_name"]').text('');
    $('[id^="js-expected_delivery"]').text('');
    $('[id^="js-tracking_status"]').text('');
    $('#js-tracking_id').text('');
    $('[data-status]').removeClass('completed');
    $('[class^="awb_"]').hide();
    $('[data-status="RTO"]').hide().removeClass('completed');
  }
  $('.track_order_btn').click(function() {
    $('.js-expected_delivery .text-medium').text('Expected date:');
    var trackid = $('#track-order-no').val().toUpperCase();
    if (trackid === "") {
      $("#track-order-no").css("border-color", "red");
      return;
    }
    resetTrackingUI();
    var url = `https://hul-services.enscommerce.in/diabetes/trackorder/delhivery/track?waybill=${encodeURIComponent(trackid)}`;
    $.ajax({
      type: "POST",
      url: url,
      contentType: 'application/json',
      data: JSON.stringify({
        awbid: trackid
      }),
      dataType: 'json',
      success: function(resultData) {
        $(".awb_reset").hide();
        $("#js-courier_awb").html("Updating");
        var jsonArray = resultData.data?.ShipmentData;
        var dataStatus = resultData.data?.status;
        var dataError = resultData.data?.Error;
        var dataSuccess = resultData.data?.Success;
        // console.log(dataStatus,"dataStatus--pp");
        if (jsonArray && jsonArray.length > 0) {
          jsonArray.forEach(function(item, index) {
            var currentObject = item?.Shipment;
            if (!currentObject) return;
            var status = currentObject.Status?.Status;
            console.log(status,"status");
            var statusType = currentObject.Status?.StatusType;
            var StatusLocation = currentObject.Status?.StatusLocation;
            var date = currentObject.ExpectedDeliveryDate;
            var returnDateTime = currentObject.Status?.StatusDateTime;
            var returnDate = returnDateTime.split("T")[0];
            var expectedDateTime = currentObject.ExpectedDeliveryDate;
            var expectedDate = expectedDateTime.split("T")[0];
            // console.log(ecpectedDate,"ecpectedDate");
            var awbNo = currentObject.AWB;
            var courier_name = currentObject.SenderName;
            const formattedDate = date ? new Date(date).toLocaleDateString('en-US', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            }) : 'N/A';
            const return_formattedDate = returnDate ? new Date(returnDate).toLocaleDateString('en-US', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            }) : 'N/A';
            const return_expectedDate = returnDate ? new Date(expectedDate).toLocaleDateString('en-US', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            }) : 'N/A';
            var className = ".awb_" + index;
            var $classBlock = $(className);
            $classBlock.show();
            $('#js-tracking_id').html(trackid);
            $('.trackOrder').show();
            $('.before_loader-gif').hide();
            $classBlock.find('#js-courier_awb').html(awbNo);
            $classBlock.find('#js-courier_name').text(courier_name);
            // console.log(currentStatus,"currentStatus");
            if(status === 'Delivered' || statusType === 'DL'){
            $classBlock.find("#js-expected_delivery").text(return_formattedDate);
            }else{
              $classBlock.find("#js-expected_delivery").text(return_expectedDate);
            }
            $classBlock.find("#js-tracking_status").text(status);
            $('[data-status="confirmed"]').addClass('completed');
            var currentStatus = (status || "").replace(/ +/g, "");
            var currentStatusType = statusType;
            $(".track-body .step").css("width", "25%");
            if (currentStatus === 'InTransit' || currentStatusType === 'UD') {
              $classBlock.find('[data-status="INTRANSIT"]').addClass('completed');
            }
            if (currentStatus === 'Dispatched') {
              $classBlock.find('[data-status="INTRANSIT"]').addClass('completed');
              $classBlock.find('[data-status="OUTFORDELIVERY"]').addClass('completed');
            }
            if (currentStatus === 'Delivered' || currentStatusType === 'DL') {
              $('.js-expected_delivery .text-medium').text('Delivered Date:');
              $classBlock.find('[data-status="INTRANSIT"]').addClass('completed');
              $classBlock.find('[data-status="OUTFORDELIVERY"]').addClass('completed');
              $classBlock.find('[data-status="SHIPMENTDELIVERED"]').addClass('completed');
            }
            if (currentStatus.match('RTO') != null) {
              $(".track-body .step").css("width", "20%");
              $('.js-expected_delivery .text-medium').text('Returned Date:');
              $classBlock.find("#js-expected_delivery").text(return_formattedDate);
              $classBlock.find('[data-status="INTRANSIT"]').addClass('completed');
              $classBlock.find('[data-status="OUTFORDELIVERY"]').addClass('completed');
              $classBlock.find('[data-status="RTO"]').show().addClass('completed');
            }
          });
        } else if (dataStatus === "IN_PROGRESS" && (!jsonArray || jsonArray.length === 0)) {
          $('.IncorrectTrackOrder').css('display', 'block');
          $('#incorrect-status').text("Your order is currently in progress. It has yet to be assigned or picked. Please visit in 4-5 hrs as it moves to the next stage.");
          $('.MainTrackOrder').css('display', 'none');
          $('.before_loader-gif').css('display', 'none');
        } else if (dataStatus === "CANCELLED" && (!jsonArray || jsonArray.length === 0)) {
          $('.IncorrectTrackOrder').css('display', 'block');
          $('#incorrect-status').text("Your order is cancelled.");
          $('.MainTrackOrder').css('display', 'none');
          $('.before_loader-gif').css('display', 'none');
        } else if (dataStatus === "NOT_FOUND" && (!jsonArray || jsonArray.length === 0)) {
          $('.IncorrectTrackOrder').css('display', 'block');
          $('#incorrect-status').text("Please enter the correct Order ID or Waybill Number.");
          $('.MainTrackOrder').css('display', 'none');
          $('.before_loader-gif').css('display', 'none');
        } else if (dataSuccess === false && dataError && dataError.toLowerCase().includes("data does not exists for provided waybill(s)")) {
          $('.IncorrectTrackOrder').css('display', 'block');
          $('#incorrect-status').text("Please enter the correct Order ID or Waybill Number.");
          $('.MainTrackOrder').css('display', 'none');
          $('.before_loader-gif').css('display', 'none');
        }
        else{
          $('.IncorrectTrackOrder').css('display', 'block');
          $('#incorrect-status').text("Your order is currently in progress. It has yet to be assigned or picked. Please visit in 4-5 hrs as it moves to the next stage.");
          $('.MainTrackOrder').css('display', 'none');
          $('.before_loader-gif').css('display', 'none');
        }
      },
      error: function(error) {
        console.log("error", error);
        $('.before_loader-gif').hide();
        $('.IncorrectTrackOrder').show();
        $('#incorrect-status').text("Something went wrong. Please try again later.");
      }
    });
  });
  // Clear error border color on input
  $("#track-order-no").on("input", function() {
    $(this).css("border-color", "");
  });
  // Optional: Support pressing "Enter" to trigger search
  $("#track-order-no").keypress(function(e) {
    if (e.which === 13) {
      $('.track_order_btn').click();
    }
  });
});